<template>
  <div>
    <Input
      v-if="!hideInput"
      v-model="qrcodeText"
      :placeholder="placeholder"
      @on-change="makeCode"
      clearable
    />
    <div ref="qrcode"></div>
  </div>
</template>
<script>
export default {
  name: "iQrcode",
  props: {
    hideInput: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Array],
      default: ""
    },
    placeholder: {
      type: String,
      default: "请输入内容，生成二维码"
    },
    config: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      qrcode: {},
      qrcodeText: ""
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let cfg = {
        text: this.value
      };
      Object.assign(cfg, this.config);
      this.qrcode = this.$utils.qrcode(this.$refs.qrcode, cfg);
    },
    makeCode() {
      this.qrcode.makeCode(this.qrcodeText);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/qrcode.vue